<div [class.caption]="_caption()">
	@if(_caption()) {
	<label>{{_caption()}}</label>
	}
	<app-button [size]="size" [label]="label()" (click)="_onDialog.set(true)"></app-button>
</div>
@if(_onDialog() ) {
<app-dialog-select [selectedItems]="_selectedItems()" (onSelected)="explorerSelected($event)"></app-dialog-select>
}
